/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { labelMenu } from '../../constants/label';
import IconTimesheet from 'assets/icons/ic_menu_timesheet_staff.svg';
import IconTimekeeping from 'assets/icons/ic_menu_timekeeping.svg';
import IconLeaveOff from 'assets/icons/ic_menu_leaveoff_staff.svg';
import IconPayslip from 'assets/icons/ic_menu_payslip.svg';
import IconContract from 'assets/icons/ic_menu_contract.svg';
import IconDevice from 'assets/icons/ic_menu_device.svg';
import IconOnOffboard from 'assets/icons/ic_menu_onoffboard_staff.svg';
import IconObservationList from 'assets/icons/ic_menu_observationlist.svg';
import {
  PERMISSION_TIMESHEET_ACCESS_PERSONAL,
  PERMISSION_PAYSLIP_ACCESS_PERSONAL,
  PERMISSION_TIMEKEEPING_ACCESS_PERSONAL,
  PERMISSION_TIMESHEET_ACCESS_OBSERVATION_LIST,
  PERMISSION_ONBOARD_ACCESS_PERSONNEL,
  PERMISSION_OFFBOARD_ACCESS_PERSONNEL,
  PERMISSION_DEVICE_ACCESS_PERSONNEL,
  PERMISSION_LEAVE_OFF_ACCESS_PERSONAL,
} from 'constants/permissions';
import { IMenuList } from 'components/interfaces/MenuListSidebar';

const Icon = (props: any) => (
  <span
    role="img"
    aria-label="fast-backward"
    className="anticon anticon-fast-backward ant-menu-item-icon"
  >
    <img alt="" src={props.src} />
  </span>
);

const MenuListStaff: IMenuList[] = [
  {
    title: labelMenu.TIMESHEET,
    icon: <Icon src={IconTimesheet} />,
    path: '/my-page/timesheet',
    permissions: [PERMISSION_TIMESHEET_ACCESS_PERSONAL.TIMESHEET_ACCESS_PERSONAL],
  },
  {
    title: labelMenu.PAYSLIP,
    icon: <Icon src={IconTimekeeping} />,
    path: '/my-page/payslip',
    permissions: [PERMISSION_TIMESHEET_ACCESS_PERSONAL.TIMESHEET_ACCESS_PERSONAL],
  },
  {
    title: labelMenu.TIMEKEEPING,
    icon: <Icon src={IconTimekeeping} />,
    path: '/my-page/timekeeping',
    permissions: [PERMISSION_TIMEKEEPING_ACCESS_PERSONAL],
  },
  {
    title: 'Performance review',
    icon: <Icon src={IconTimekeeping} />,
    path: '/my-page/performance-review',
    permissions: ['PERFORMANCE_ACCESS_PERSONAL'],
  },
  {
    title: labelMenu.LEAVE_OFF,
    icon: <Icon src={IconLeaveOff} />,
    path: '/my-page/leave-off',
    permissions: [PERMISSION_LEAVE_OFF_ACCESS_PERSONAL],
  },
  // {
  //   //Tạm ẩn tính năng chưa phát triển xong
  //   title: labelMenu.PAYSLIP,
  //   icon: <Icon src={IconPayslip} />,
  //   path: '/my-page/payslip',
  //   permissions: [PERMISSION_PAYSLIP_ACCESS_PERSONAL],
  // },
  // {
  //   //Tạm ẩn tính năng chưa phát triển xong
  //   title: labelMenu.CONTRACT,
  //   icon: <Icon src={IconContract} />,
  //   path: '/my-page/contract',
  //   permissions: [PERMISSION_PAYSLIP_ACCESS_PERSONAL],
  // },
  // {
  //   //Tạm ẩn tính năng chưa phát triển xong
  //   title: labelMenu.DEVICE,
  //   icon: <Icon src={IconDevice} />,
  //   path: '/my-page/device',
  //   permissions: [PERMISSION_DEVICE_ACCESS_PERSONNEL.DEVICE_ACCESS_PERSONNEL],
  // },

  //hide on off board as MrNhan discussed
  // {
  //   title: labelMenu.ON_OFF_BOARD,
  //   icon: <Icon src={IconOnOffboard} />,
  //   path: '/my-page/on-off',
  //   menu: [
  //     {
  //       title: labelMenu.ONBOARD,
  //       path: '/onboard',
  //       permissions: [PERMISSION_ONBOARD_ACCESS_PERSONNEL.ONBOARD_ACCESS_PERSONNEL],
  //     },
  //     {
  //       title: labelMenu.OFFBOARD,
  //       path: '/offboard',
  //       permissions: [PERMISSION_OFFBOARD_ACCESS_PERSONNEL.OFFBOARD_ACCESS_PERSONNEL],
  //     },
  //   ],
  //   permissions: [
  //     PERMISSION_ONBOARD_ACCESS_PERSONNEL.ONBOARD_ACCESS_PERSONNEL,
  //     PERMISSION_OFFBOARD_ACCESS_PERSONNEL.OFFBOARD_ACCESS_PERSONNEL,
  //   ],
  // },

  // {
  //   title: labelMenu.OBSERVATION_LIST,
  //   icon: <Icon src={IconObservationList} />,
  //   path: '/my-page/observation_list',
  //   permissions: [PERMISSION_TIMESHEET_ACCESS_OBSERVATION_LIST.TIMESHEET_ACCESS_OBSERVATION_LIST],
  // },
];

export default MenuListStaff;
